(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('LocalStorageService', function($log, $window, $timeout, InfoService, Principal) {

		var VERSION_KEY = '__LS_VERSIONS';

		this.versions = {};
		this.trackers = {};

		// Event change listener is disable for performance reasons
		// In IE this may create many digests cycles
		var CHANGE_LISTENER_ENABLED = false;

		var instance = this;

		var prefix = null;
		var version = null;
		var login = null;

		var globalKeys = {};

		Principal.identity().then(function(account) {
			login = account !== null ? (account.email ? account.email : account.login) : '';
		});

		var getKey = function(key) {
			var k = key;
			if (!globalKeys[key]) {
				k = prefix + '_';
				if (version && '' !== version) {
					k += version + '_';
				} else {
					k += InfoService.getVersion() + '_';
				}
				k += login + '_';
				k += key;
			}
			return k;
		};

		var doSetValue = function(key, value, updtVersion) {
			var itemValue = null;
			if (localStorage !== null) {
				try {
					itemValue = JSON.stringify(value);
				} catch (e) {
					itemValue = value;
				}
				localStorage.setItem(getKey(key), itemValue);
				$log.debug('LocalStorageService: setValue() key: ' + key + '.');
				if (updtVersion) {
					updateVersion(key);
				}
			}
		};

		var updateVersion = function(key) {
			instance.versions[key] = new Date().getTime();
			doSetValue(VERSION_KEY, instance.versions, false);
			$log.debug('LocalStorageService: Version updated for ' + key);
		};

		var handleVersionChanges = function(changes, lsVersions) {
			for (var i = 0; i < changes.length; i++) {
				var key = changes[i];
				// let's update our version with the version from the local storage
				instance.versions[key] = lsVersions[key];

				var tracker = instance.trackers[key];
				if (tracker !== undefined && tracker !== null) {
					$log.debug('LocalStorageService: Tracker found for key: [' + key + '].');
					tracker();
				}
			}
		};

		var detectVersionChanges = function() {
			$log.debug('LocalStorageService: Detecting version modifications...');
			var keyChanges = [];
			var lsVersions = instance.getValue(VERSION_KEY);
			for (var key in lsVersions) {
				if (instance.versions[key] !== lsVersions[key]) {
					keyChanges.push(key);
				}
			}
			$log.debug('LocalStorageService: Following versions are not up to date: [' + keyChanges + '].');

			handleVersionChanges(keyChanges, lsVersions);
		};

		var initChangeListener = function() {
			if (CHANGE_LISTENER_ENABLED === true) {
				$window.addEventListener('storage', function() {
					$timeout(function() {
						detectVersionChanges();
					});
				});
			}
		};

		initChangeListener();

		this.setVersion = function(v) {
			version = v;
		};

		this.setLogin = function(l) {
			login = l;
		};

		this.setPrefix = function(p) {
			prefix = p;
		};

		/**
		 * True if the value is set
		 * @param {type} key the key to check
		 * @returns {Boolean} true when a value is set for the key
		 */
		this.isValueSet = function(key) {
			var v = this.getValue(key);
			return v !== null && v !== '';
		};

		/**
		 * Get the value attached to a key or null if not set
		 * @param {String} key the value to get
		 * @returns {Object} the value behind the key
		 */
		this.getValue = function(key) {
			var value = null;
			if (localStorage !== null) {
				var item = localStorage.getItem(getKey(key));

				$log.debug('LocalStorageService: getValue() key: ' + key + '.');

				if (item !== null) {
					try {
						value = JSON.parse(item);
					} catch (e) {
						value = item;
					}
				}
			}
			return value;
		};

		/**
		 * Set the value for a key
		 * @param {String} key the key to use
		 * @param {Object} value the value to save in the local storage
		 */
		this.setValue = function(key, value) {
			doSetValue(key, value, true);
		};



		/**
		 * Clear the value attached to the key
		 * @param {String} key the key to remove from the local storage
		 */
		this.clearValue = function(key) {
			this.setValue(key, null);
		};

		/**
		 * Register a tracker for a value. When the value is changed from the local storage, the tracker function is called.
		 * @param {String} key key to bind the tracker
		 * @param {type} fn the function called when data have changed
		 */
		this.registerValueTracker = function(key, fn) {
			this.trackers[key] = fn;
		};

		/**
		 * Add a global key (the key is not composed from version / user)
		 * @param {String} key the key that is now global
		 */
		this.addGlobalKey = function(key) {
			globalKeys[key] = true;
		};
	});
})(angular);